import React, { useState, useReducer, useEffect } from 'react';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';

import utils from '../../utils'
import AuthService from '../../services/auth-service';
import LoadingSpinner from '../../comp/gen/LoadingSpinner';
import UserAuthRequired from '../../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";

import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';

import { Autocomplete, Stack, Paper, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import LinearProgress from '@mui/material/LinearProgress';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import notify from 'devextreme/ui/notify';

// ************************************************************
// ************************************************************
// ************************************************************

export default function ComputerListAddNewFormDialog(props) {
   
  const [userData, setUserData] = React.useState({})

  const handleClose = () => {
    props.onClickClose()
    setUserData({})    
  }
  const handleSubmit = () => {
    console.log(userData)
    props.onClickSubmit(userData)
    setUserData({})    
  }
  const handleTextBoxChange = (e) => {
    const { id, value } = e.target;
    console.log(value);
    setUserData(prevData => ({
      ...prevData,
      [id]: value
    }))
  }  
  
  // **********************************************************
  // **********************************************************
  // **********************************************************

  var view_en = {
    cancel_button: true,
    build_button: true,
    show_spin: false,
  }  
  
  if (props.spin || props.dataLoading) {
    view_en.cancel_button = false
    view_en.build_button = false
    view_en.show_spin = true
  }
    
  // **********************************************************
  // **********************************************************
  // **********************************************************
  
  return (    
    <div>      
      <Dialog 
        maxWidth='sm'
        fullWidth={true}
        open={props.open} 
        //onClose={handleClose}
      >
        <DialogTitle>ADD NEW COMPUTER</DialogTitle>
        <DialogContent>
          <Stack spacing={3}>
              <TextField
                value={userData.user_code}
                margin="dense"
                required
                id="user_code"
                label="User code"
                onChange={handleTextBoxChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <TextField
                value={userData.username}
                margin="dense"
                required
                id="username"
                label="Username"
                onChange={handleTextBoxChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <FormControl fullWidth margin="dense" variant="standard" disabled={view_en.show_spin}>
                <InputLabel>Reseller</InputLabel>
                <Select
                  value={props.resellerId}
                  onChange={props.onResellerIdChanged}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select a reseller</MenuItem>
                  {props.resellersRows.map(row => (
                    <MenuItem key={row.id} value={row.id}>{row.view_text}</MenuItem>
                  ))}
                </Select>
              </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={!view_en.cancel_button} onClick={handleClose}>Cancel</Button>
          <Button disabled={!view_en.build_button} onClick={handleSubmit}>Submit</Button>
        </DialogActions>
        {view_en.show_spin && <LinearProgress />}
      </Dialog>
    </div>
  );
}
